// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StockProductsTab_container__YyPAd {
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 12px;
}

/* Карточки */
.StockProductsTab_stats__7cN3i {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.StockProductsTab_card__XmrPS {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.StockProductsTab_card__XmrPS p {
  font-size: 14px;
  color: #555;
  margin: 0;
}

.StockProductsTab_card__XmrPS h3 {
  margin: 2px 0 0;
  font-weight: 600;
}

.StockProductsTab_cardIcon__MpR28 {
  font-size: 24px;
  opacity: 0.9;
}

.StockProductsTab_blue__sj6aT .StockProductsTab_cardIcon__MpR28 {
  color: #007bff;
}

.StockProductsTab_green__fQ-l3 .StockProductsTab_cardIcon__MpR28 {
  color: #2e7d32;
}

.StockProductsTab_gray__B2An1 .StockProductsTab_cardIcon__MpR28 {
  color: #555;
}

/* Фильтры */
.StockProductsTab_filters__wuME0 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.StockProductsTab_filters__wuME0 select,
.StockProductsTab_filters__wuME0 input {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  min-width: 160px;
  outline: none;
  transition: border-color 0.2s ease;
}

.StockProductsTab_filters__wuME0 select:focus,
.StockProductsTab_filters__wuME0 input:focus {
  border-color: #1d8752;
}

/* Таблица (твой стиль) */
.StockProductsTab_tableWrapper__Rmfqg {
  max-height: 24vw;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  position: relative;
  background: #fff;
}

.StockProductsTab_table__AXDAN {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.StockProductsTab_table__AXDAN thead th {
  position: sticky;
  top: 0;
  z-index: 5;
  background-color: #f9f9f9;
}

.StockProductsTab_table__AXDAN th,
.StockProductsTab_table__AXDAN td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  font-size: 14px;
}

.StockProductsTab_table__AXDAN th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333;
}

.StockProductsTab_table__AXDAN tr:hover {
  background-color: #f5f5f5;
}

.StockProductsTab_emptyText__57lr0 {
  text-align: center;
  color: #999;
  padding: 20px 0;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AnalyticsPages/StockProductsTab.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".container {\n  background-color: #f5f5f5;\n  padding: 20px;\n  border-radius: 12px;\n}\n\n/* Карточки */\n.stats {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.card {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #fff;\n  border-radius: 10px;\n  padding: 16px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.card p {\n  font-size: 14px;\n  color: #555;\n  margin: 0;\n}\n\n.card h3 {\n  margin: 2px 0 0;\n  font-weight: 600;\n}\n\n.cardIcon {\n  font-size: 24px;\n  opacity: 0.9;\n}\n\n.blue .cardIcon {\n  color: #007bff;\n}\n\n.green .cardIcon {\n  color: #2e7d32;\n}\n\n.gray .cardIcon {\n  color: #555;\n}\n\n/* Фильтры */\n.filters {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.filters select,\n.filters input {\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 14px;\n  min-width: 160px;\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.filters select:focus,\n.filters input:focus {\n  border-color: #1d8752;\n}\n\n/* Таблица (твой стиль) */\n.tableWrapper {\n  max-height: 24vw;\n  overflow-y: auto;\n  overflow-x: auto;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  position: relative;\n  background: #fff;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  background-color: #f9f9f9;\n}\n\n.table th,\n.table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n  font-size: 14px;\n}\n\n.table th {\n  background-color: #f9f9f9;\n  font-weight: 600;\n  color: #333;\n}\n\n.table tr:hover {\n  background-color: #f5f5f5;\n}\n\n.emptyText {\n  text-align: center;\n  color: #999;\n  padding: 20px 0;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StockProductsTab_container__YyPAd`,
	"stats": `StockProductsTab_stats__7cN3i`,
	"card": `StockProductsTab_card__XmrPS`,
	"cardIcon": `StockProductsTab_cardIcon__MpR28`,
	"blue": `StockProductsTab_blue__sj6aT`,
	"green": `StockProductsTab_green__fQ-l3`,
	"gray": `StockProductsTab_gray__B2An1`,
	"filters": `StockProductsTab_filters__wuME0`,
	"tableWrapper": `StockProductsTab_tableWrapper__Rmfqg`,
	"table": `StockProductsTab_table__AXDAN`,
	"emptyText": `StockProductsTab_emptyText__57lr0`
};
export default ___CSS_LOADER_EXPORT___;
